export { getDatabaseUrl } from './getDatabaseUrl';
